import { render, staticRenderFns } from "./videoButton.vue?vue&type=template&id=5035af5f&scoped=true&"
import script from "./videoButton.vue?vue&type=script&lang=js&"
export * from "./videoButton.vue?vue&type=script&lang=js&"
import style0 from "./videoButton.vue?vue&type=style&index=0&id=5035af5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035af5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5035af5f')) {
      api.createRecord('5035af5f', component.options)
    } else {
      api.reload('5035af5f', component.options)
    }
    module.hot.accept("./videoButton.vue?vue&type=template&id=5035af5f&scoped=true&", function () {
      api.rerender('5035af5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/videoButton.vue"
export default component.exports